import $ from 'jquery';

const language_switcher_init = () => {
   $("form#nomadia_form_language_switcher select").on('change', (e) =>  window.location = e.currentTarget.value)
}

export {language_switcher_init};
